import { type AppLocale, t, type TVars } from '@spin/shared';
import { useCallback } from 'react';
import { ApiError } from './api/http';
import { useLocale, useSession } from './store/session';
import { useUi } from './store/ui';

export type Translate = (key: string, vars?: TVars) => string;

export function useT(): Translate {
  const locale = useLocale();
  return useCallback((key: string, vars?: TVars) => t(locale, key, vars), [locale]);
}

export function tNow(key: string, vars?: TVars): string {
  const me = useSession.getState().me;
  return t((me?.locale ?? 'en') as AppLocale, key, vars);
}

/** Shows a localized toast for any failure (API errors map to `errors.<CODE>`). */
export function reportError(err: unknown): void {
  const code = err instanceof ApiError ? err.code : 'INTERNAL_ERROR';
  useUi.getState().toast(tNow(`errors.${code}`), 'error');
}
